<template>
	<div id="poster" v-if="loaded" class="page">
		<div class="poster-box">
			<div v-for="item in posterList">
				<router-link :to="{path:'/posterset',query:{id:item.id}}">
					<img v-bind:src="item.image"/>
					<span>{{item.subject}}</span>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import { Toast } from 'we-vue'
export default {
  data () {
    return {
		loaded:false,
		posterList:[]
	}
  },
  mounted () {
	if(!this.$store.state.userInfo.driver_level.poster){
		this.$wx.showToast('您没有使用招生海报的权限')
		this.$router.push('/News')
		return false;
	}
  },
  created(){
	this.loaded = true
	this.$app.pr('/api/zposter/lists').then((res) => {
		console.log(res.data)
		this.posterList = res.data
	}).catch((res) => {});
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style scoped>
	#poster{
		background-color:#FFFFFF;
		min-height:100vh;
	}
	.poster-box{
		padding:3vw;
	}
	.poster-box div{
		display:inline-block;
		width:45.5vw;
		margin-bottom:3vw;
	}
	.poster-box div:nth-child(2n){
		display:inline-block;
		margin-left:3vw;
		width:45.5vw;
	}
	.poster-box div img{
		width:100%;
		height:72vw;
	}
	.poster-box div span{
		font-size:4vw;
		color:#5D5D5D;
		line-height:8vw;
	}
</style>


// WEBPACK FOOTER //
// src/components/Poster.vue